export default [
  {
    path: '/index',
    redirect: '/',
    hidden: true
  }
]
